var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isTranslated)?_c('TopBar'):_vm._e(),_c('RouterView'),(!_vm.pagesWithoutFooter.includes(_vm.$route.name) && _vm.isTranslated)?_c('FooterContact'):_vm._e(),(_vm.isTranslated)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }